import { useState, useMemo } from 'react';
import { capitalizeFirstLetter } from '../../../utils/utils';
import { lang } from '../../generales/traduction';

const ModalHostStatusListNew = ({
  statusSelectedText,
  statusSelected,
  languaje,
  mode,
  server,
  handleShowPopup,
  closHostsListModal,
  source,
}) => {
  const [searchTerm, setSearchTerm]     = useState('');
  const [limitList, setLimitList]       = useState(50);
  const [pageActual, setPageActual]     = useState(1);
  const [filtroActivo, setFiltroActivo] = useState('todos');

  /* ── CSV helpers (preserved exactly from original) ── */
  function normalizeHostToCSVRow(item) {
    return {
      id: item.id,
      host: item.name,
      ip: item.ip ?? '',
      status: item.status === 'ok' ? 'Conectado' : item.status === 'offline' ? 'Desconectado' : 'Desconocido',
      'en excepcion':    item.is_exception   ? 'Si' : 'No',
      'en mantenimiento': item.in_maintenance ? 'Si' : 'No',
      'Tiempo Desconexión (formato horas)': item.duration ?? '',
      'Tiempo Desconexión (formato Fecha)': item.disconnected_since ?? '',
      tecnologia: item.tech?.name ?? '',
      zonas:   Array.isArray(item.zones)  ? item.zones.map(z => z.name).join(' | ')  : '',
      grupos:  Array.isArray(item.groups) ? item.groups.map(g => g.name).join(' | ') : '',
      afiliacion: item.parent_id ?? '',
    };
  }
  function arrayToCSV(data) {
    if (!Array.isArray(data) || data.length === 0) return '';
    const headers = Object.keys(data[0]);
    const rows = [headers.join(',')];
    data.forEach(row => {
      rows.push(headers.map(h => `"${String(row[h]).replace(/"/g, '""')}"`).join(','));
    });
    return rows.join('\n');
  }
  function downloadCSV(arr, filename = 'hosts.csv') {
    const blob = new Blob([arrayToCSV(arr.map(normalizeHostToCSVRow))], { type: 'text/csv;charset=utf-8;' });
    const url  = URL.createObjectURL(blob);
    const a    = document.createElement('a');
    a.href = url; a.download = filename; a.click();
    URL.revokeObjectURL(url);
  }

  /* ── Derived data ── */
  const filteredData = useMemo(() => {
    let base = statusSelected || [];
    if (filtroActivo === 'excepcion')    base = base.filter(h => h.is_exception);
    if (filtroActivo === 'mantenimiento') base = base.filter(h => h.in_maintenance);
    if (searchTerm.trim()) {
      const q = searchTerm.toLowerCase();
      base = base.filter(h =>
        (h.parent_id || '').toLowerCase().includes(q) ||
        (h.name     || '').toLowerCase().includes(q) ||
        (h.ip       || '').toLowerCase().includes(q)
      );
    }
    return base;
  }, [statusSelected, filtroActivo, searchTerm]);

  const lim       = parseInt(limitList);
  const totalPages = Math.max(1, Math.ceil(filteredData.length / lim));
  const start      = lim * (pageActual - 1);
  const pageData   = filteredData.slice(start, start + lim);
  const desde      = filteredData.length === 0 ? 0 : start + 1;
  const hasta      = Math.min(start + lim, filteredData.length);

  const setFiltro = f => { setFiltroActivo(f); setPageActual(1); };

  /* ── Style helpers ── */
  const headerBadge = () => {
    const t = (statusSelectedText || '').toLowerCase();
    if (t.includes('conectado') && !t.includes('des')) return { background:'#d1fae5', color:'#057a55', border:'1px solid #a7f3d0' };
    if (t.includes('desconectado'))  return { background:'#fce7f3', color:'#db2777', border:'1px solid #fbcfe8' };
    if (t.includes('desconocido'))   return { background:'#f1f5f9', color:'#64748b', border:'1px solid #e2e8f0' };
    if (t.includes('excepci'))       return { background:'#ede9fe', color:'#7e3af2', border:'1px solid #c4b5fd' };
    if (t.includes('mantenimiento')) return { background:'#fef3c7', color:'#d97706', border:'1px solid #fde68a' };
    return { background:'#f1f5f9', color:'#64748b', border:'1px solid #e2e8f0' };
  };
  const dotStyle = s => {
    if (s === 'ok')      return { background:'#057a55', boxShadow:'0 0 0 2px rgba(5,122,85,.15)' };
    if (s === 'offline') return { background:'#db2777', boxShadow:'0 0 0 2px rgba(219,39,119,.15)' };
    return { background:'#94a3b8', boxShadow:'none' };
  };
  const statusBadge = d => {
    if (d.is_exception)   return { bg:{ background:'#ede9fe', color:'#7e3af2', border:'1px solid #c4b5fd' }, label:'Excepción' };
    if (d.in_maintenance) return { bg:{ background:'#fef3c7', color:'#d97706', border:'1px solid #fde68a' }, label:'Mantto.' };
    if (d.status === 'ok')      return { bg:{ background:'#d1fae5', color:'#057a55', border:'1px solid #a7f3d0' }, label:'Conectado' };
    if (d.status === 'offline') return { bg:{ background:'#fce7f3', color:'#db2777', border:'1px solid #fbcfe8' }, label:'Desconectado' };
    return { bg:{ background:'#f1f5f9', color:'#64748b', border:'1px solid #e2e8f0' }, label:'Desconocido' };
  };

  const pagBtn = (active) => ({
    width:26, height:26, border:`1px solid ${active?'#1a56db':'#e2e8f0'}`,
    borderRadius:4, background: active?'#1a56db':'#fff',
    color: active?'#fff':'#64748b', fontSize:11, cursor:'pointer',
    display:'flex', alignItems:'center', justifyContent:'center',
  });

  /* page numbers with ellipsis */
  const pageNums = (() => {
    if (totalPages <= 7) return Array.from({length:totalPages},(_,i)=>i+1);
    const s = new Set([1, totalPages, pageActual, pageActual-1, pageActual+1].filter(p=>p>=1&&p<=totalPages));
    return [...s].sort((a,b)=>a-b);
  })();

  return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      position: 'fixed', inset: 0, zIndex: 50,
      pointerEvents: 'none',
    }}>
      <div style={{ pointerEvents: 'all' }}>
      <style>{`
        @keyframes slideUpDL { from{opacity:0;transform:translateY(12px)} to{opacity:1;transform:translateY(0)} }
        .dl-tr:hover td { background:#f0f5ff !important; }
        .dl-search:focus-within { border-color:#1a56db !important; }
        .dl-fbtn { transition:opacity .15s; } .dl-fbtn:hover { opacity:.8; }
      `}</style>

      <div style={{
        background:'#fff', borderRadius:12,
        width:'100%', maxWidth:800, maxHeight:'88vh',
        boxShadow:'0 20px 60px rgba(0,0,0,.3)',
        overflow:'hidden', display:'flex', flexDirection:'column',
        animation:'slideUpDL 0.2s ease',
      }}>

        {/* ═══ HEADER ═══════════════════════════════════════════ */}
        <div style={{ background:'#0f2d5e', padding:'13px 18px', display:'flex', alignItems:'center', gap:12, flexShrink:0 }}>
          <div style={{ width:30, height:30, borderRadius:7, flexShrink:0, background:'rgba(255,255,255,.12)', display:'flex', alignItems:'center', justifyContent:'center' }}>
            <svg width="15" height="15" viewBox="0 0 16 16" fill="none">
              <circle cx="8" cy="8" r="5.5" stroke="#fff" strokeWidth="1.3" opacity=".55"/>
              <circle cx="8" cy="8" r="2.5" fill="#fff"/>
              <line x1="8" y1="1.5" x2="8" y2="3.5" stroke="#fff" strokeWidth="1.3" strokeLinecap="round"/>
              <line x1="8" y1="12.5" x2="8" y2="14.5" stroke="#fff" strokeWidth="1.3" strokeLinecap="round"/>
              <line x1="1.5" y1="8" x2="3.5" y2="8" stroke="#fff" strokeWidth="1.3" strokeLinecap="round"/>
              <line x1="12.5" y1="8" x2="14.5" y2="8" stroke="#fff" strokeWidth="1.3" strokeLinecap="round"/>
            </svg>
          </div>

          <div style={{ flex:1 }}>
            <div style={{ fontSize:13, fontWeight:500, color:'#fff' }}>Listado de dispositivos</div>
            <div style={{ fontSize:10, color:'rgba(255,255,255,.5)', marginTop:2, display:'flex', alignItems:'center', gap:6 }}>
              <span>Dispositivos con estatus</span>
              <span style={{ display:'inline-flex', alignItems:'center', borderRadius:5, padding:'2px 8px', fontSize:10, fontWeight:600, ...headerBadge() }}>
                {statusSelectedText}
              </span>
            </div>
          </div>

          {/* CSV */}
          <button onClick={() => downloadCSV(statusSelected, `reporte_dispositivos_${statusSelectedText}.csv`)} style={{
            display:'flex', alignItems:'center', gap:5,
            border:'0.5px solid rgba(255,255,255,.2)', background:'rgba(255,255,255,.1)',
            borderRadius:6, padding:'5px 12px', fontSize:10, color:'rgba(255,255,255,.85)', cursor:'pointer',
          }}>
            <svg width="11" height="11" viewBox="0 0 16 16" fill="none">
              <path d="M8 2v8M5 7l3 3 3-3" stroke="rgba(255,255,255,.8)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M3 12h10" stroke="rgba(255,255,255,.8)" strokeWidth="1.5" strokeLinecap="round"/>
            </svg>
            CSV
          </button>

          {/* Close */}
          <button onClick={closHostsListModal} style={{
            width:26, height:26, borderRadius:6, flexShrink:0,
            border:'0.5px solid rgba(255,255,255,.15)', background:'rgba(255,255,255,.08)',
            cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center', color:'rgba(255,255,255,.6)',
          }}>
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>
        </div>

        {/* ═══ TOOLBAR ══════════════════════════════════════════ */}
        <div style={{
          background:'#f1f5f9', borderBottom:'1px solid #e2e8f0',
          padding:'8px 16px', display:'flex', alignItems:'center',
          justifyContent:'space-between', gap:10, flexShrink:0, flexWrap:'wrap',
        }}>
          <div style={{ display:'flex', alignItems:'center', gap:8, flexWrap:'wrap' }}>
            <span style={{ fontSize:11, color:'#334155', fontWeight:500 }}>
              Resultados:{' '}
              <span style={{ fontFamily:'monospace', fontWeight:600, color:'#1a56db' }}>{filteredData.length}</span>
            </span>
            <div style={{ display:'flex', gap:4 }}>
              {/* Todos */}
              <button className="dl-fbtn" onClick={() => setFiltro('todos')} style={{
                background: filtroActivo==='todos'?'#1a56db':'#e8f0fe',
                color:       filtroActivo==='todos'?'#fff':'#1a56db',
                border:'1px solid #c3dafe', borderRadius:5, padding:'3px 8px', fontSize:9, fontWeight:500, cursor:'pointer',
              }}>Todos</button>

              {/* Con excepción */}
              <button className="dl-fbtn" onClick={() => setFiltro('excepcion')} style={{
                background: filtroActivo==='excepcion'?'#7e3af2':'#ede9fe',
                color:       filtroActivo==='excepcion'?'#fff':'#7e3af2',
                border:'1px solid #c4b5fd', borderRadius:5, padding:'3px 8px', fontSize:9, fontWeight:500,
                cursor:'pointer', display:'flex', alignItems:'center', gap:4,
              }}>
                <svg width="9" height="9" viewBox="0 0 10 10" fill="none">
                  <path d="M5 1L9.5 9H.5L5 1Z" stroke="currentColor" strokeWidth="1.1"/>
                  <line x1="5" y1="4" x2="5" y2="6.5" stroke="currentColor" strokeWidth="1" strokeLinecap="round"/>
                </svg>
                Con excepción
              </button>

              {/* En mantenimiento */}
              <button className="dl-fbtn" onClick={() => setFiltro('mantenimiento')} style={{
                background: filtroActivo==='mantenimiento'?'#d97706':'#fef3c7',
                color:       filtroActivo==='mantenimiento'?'#fff':'#d97706',
                border:'1px solid #fde68a', borderRadius:5, padding:'3px 8px', fontSize:9, fontWeight:500,
                cursor:'pointer', display:'flex', alignItems:'center', gap:4,
              }}>
                <svg width="10" height="10" viewBox="0 0 16 16" fill="none">
                  <path d="M11 2.5a3.5 3.5 0 0 1 .6 6.5L7 14a2 2 0 0 1-2.8-2.8L9.8 6a3.5 3.5 0 0 1 1.2-3.5z" fill="#fbbf24" stroke="currentColor" strokeWidth=".8" strokeLinejoin="round"/>
                  <path d="M11.5 2l1 1-1.5 1.5-1-1z" fill="currentColor"/>
                  <circle cx="5.5" cy="11.5" r="1" fill="currentColor"/>
                </svg>
                En mantenimiento
              </button>
            </div>
          </div>

          {/* Search */}
          <div className="dl-search" style={{
            display:'flex', alignItems:'center', gap:6,
            background:'#fff', border:'1px solid #e2e8f0', borderRadius:6,
            padding:'5px 10px', minWidth:230, transition:'border-color .15s',
          }}>
            <svg width="12" height="12" viewBox="0 0 16 16" fill="none">
              <circle cx="6.5" cy="6.5" r="4.5" stroke="#94a3b8" strokeWidth="1.5"/>
              <line x1="10" y1="10" x2="14" y2="14" stroke="#94a3b8" strokeWidth="1.5" strokeLinecap="round"/>
            </svg>
            <input
              placeholder="Buscar afiliación, dispositivo, IP..."
              value={searchTerm}
              onChange={e => { setSearchTerm(e.target.value); setPageActual(1); }}
              style={{ border:'none', outline:'none', fontSize:11, color:'#334155', width:'100%', background:'transparent' }}
            />
          </div>
        </div>

        {/* ═══ TABLE ════════════════════════════════════════════ */}
        <div style={{ flex:1, overflowY:'auto' }}>
          <table style={{ width:'100%', borderCollapse:'collapse', fontSize:10, tableLayout:'fixed' }}>
            <thead style={{ position:'sticky', top:0, zIndex:1 }}>
              <tr style={{ background:'#0f2d5e' }}>
                {[
                  ['Afiliación','22%'],['Dispositivo','24%'],['IP','13%'],
                  ['Tecnología','13%'],['Ubicación','16%'],['Estado','12%'],
                ].map(([label, w], i, arr) => (
                  <th key={i} style={{
                    width:w, padding:'8px 12px', color:'#fff', fontSize:9,
                    fontWeight:500, textAlign:'left', textTransform:'uppercase', letterSpacing:'.06em',
                    borderRight: i === arr.length-1 ? 'none' : '1px solid rgba(255,255,255,.08)',
                  }}>{label}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {pageData.length === 0 ? (
                <tr>
                  <td colSpan={6} style={{ padding:40, textAlign:'center', color:'#94a3b8', fontSize:12 }}>
                    Sin resultados para mostrar
                  </td>
                </tr>
              ) : pageData.map((d, i) => {
                const dot   = dotStyle(d.status);
                const badge = statusBadge(d);
                const both  = d.is_exception && d.in_maintenance;
                return (
                  <tr key={i} className="dl-tr" style={{ cursor:'default' }}>

                    {/* AFILIACIÓN */}
                    <td style={{ padding:'9px 12px', borderBottom:'1px solid #f1f5f9', borderRight:'1px solid #f1f5f9' }}>
                      <div style={{ display:'flex', alignItems:'center', gap:5 }}>
                        <span style={{ width:8, height:8, borderRadius:'50%', flexShrink:0, background:dot.background, boxShadow:dot.boxShadow }} />
                        {d.is_exception && (
                          <span title="Con excepción" style={{ display:'inline-flex', width:15, height:15, flexShrink:0 }}>
                            <svg width="13" height="13" viewBox="0 0 14 14" fill="none">
                              <path d="M7 1.5L12.5 11.5H1.5L7 1.5Z" stroke="#7e3af2" strokeWidth="1.3" fill="rgba(126,58,242,.08)"/>
                              <line x1="7" y1="5.5" x2="7" y2="8.5" stroke="#7e3af2" strokeWidth="1.2" strokeLinecap="round"/>
                              <circle cx="7" cy="10" r=".65" fill="#7e3af2"/>
                            </svg>
                          </span>
                        )}
                        {d.in_maintenance && (
                          <span title="En mantenimiento" style={{ display:'inline-flex', width:15, height:15, flexShrink:0 }}>
                            <svg width="13" height="13" viewBox="0 0 16 16" fill="none">
                              <path d="M11 2.5a3.5 3.5 0 0 1 .6 6.5L7 14a2 2 0 0 1-2.8-2.8L9.8 6a3.5 3.5 0 0 1 1.2-3.5z" fill="#fbbf24" stroke="#d97706" strokeWidth=".8" strokeLinejoin="round"/>
                              <path d="M11.5 2l1 1-1.5 1.5-1-1z" fill="#d97706"/>
                              <circle cx="5.5" cy="11.5" r="1" fill="#d97706"/>
                            </svg>
                          </span>
                        )}
                        <span style={{ fontSize:10, color:'#334155', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>
                          {d.parent_id}
                        </span>
                      </div>
                    </td>

                    {/* DISPOSITIVO */}
                    <td style={{ padding:'9px 12px', borderBottom:'1px solid #f1f5f9', borderRight:'1px solid #f1f5f9', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>
                      <span style={{ fontSize:10, color:'#1a56db', fontWeight:500 }}>{d.name}</span>
                    </td>

                    {/* IP */}
                    <td style={{ padding:'9px 12px', borderBottom:'1px solid #f1f5f9', borderRight:'1px solid #f1f5f9' }}>
                      <span style={{ fontFamily:'monospace', fontSize:9, color:'#64748b' }}>{d.ip}</span>
                    </td>

                    {/* TECNOLOGÍA */}
                    <td style={{ padding:'9px 12px', borderBottom:'1px solid #f1f5f9', borderRight:'1px solid #f1f5f9' }}>
                      <span style={{ display:'inline-block', background:'#f1f5f9', border:'1px solid #e2e8f0', borderRadius:4, padding:'2px 7px', fontSize:9, color:'#334155', fontWeight:500 }}>
                        {d.tech?.name}
                      </span>
                    </td>

                    {/* UBICACIÓN */}
                    <td style={{ padding:'9px 12px', borderBottom:'1px solid #f1f5f9', borderRight:'1px solid #f1f5f9', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>
                      <span style={{ fontSize:10, color:'#64748b' }}>{d.zones?.[0]?.name}</span>
                    </td>

                    {/* ESTADO */}
                    <td style={{ padding:'9px 12px', borderBottom:'1px solid #f1f5f9' }}>
                      {both ? (
                        <div style={{ display:'flex', gap:3, flexWrap:'wrap' }}>
                          <span style={{ display:'inline-flex', alignItems:'center', borderRadius:4, padding:'2px 6px', fontSize:8, fontWeight:500, border:'1px solid #c4b5fd', background:'#ede9fe', color:'#7e3af2' }}>Exc.</span>
                          <span style={{ display:'inline-flex', alignItems:'center', borderRadius:4, padding:'2px 6px', fontSize:8, fontWeight:500, border:'1px solid #fde68a', background:'#fef3c7', color:'#d97706' }}>Mant.</span>
                        </div>
                      ) : (
                        <span style={{ display:'inline-flex', alignItems:'center', borderRadius:4, padding:'2px 7px', fontSize:9, fontWeight:500, ...badge.bg }}>
                          {badge.label}
                        </span>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        {/* ═══ FOOTER ═══════════════════════════════════════════ */}
        <div style={{
          padding:'8px 16px', borderTop:'1px solid #e2e8f0', background:'#f1f5f9',
          display:'flex', alignItems:'center', justifyContent:'space-between', flexWrap:'wrap', gap:8, flexShrink:0,
        }}>
          {/* Filas por página */}
          <div style={{ display:'flex', alignItems:'center', gap:5, fontSize:10, color:'#64748b' }}>
            Filas por página:
            <select value={limitList} onChange={e => { setLimitList(parseInt(e.target.value)); setPageActual(1); }} style={{
              fontSize:10, padding:'3px 5px', border:'1px solid #e2e8f0',
              borderRadius:4, color:'#334155', background:'#fff', outline:'none',
            }}>
              <option value={25}>25</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
              <option value={500}>500</option>
            </select>
          </div>

          {/* Paginación */}
          <div style={{ display:'flex', gap:4, alignItems:'center' }}>
            <button onClick={() => setPageActual(p => Math.max(1,p-1))} style={pagBtn(false)}>«</button>
            {pageNums.map((p, i, arr) => (
              <>
                {i > 0 && arr[i]-arr[i-1] > 1 && <span key={`e${i}`} style={{ fontSize:10, color:'#94a3b8', alignSelf:'center' }}>…</span>}
                <button key={p} onClick={() => setPageActual(p)} style={pagBtn(p===pageActual)}>{p}</button>
              </>
            ))}
            <button onClick={() => setPageActual(p => Math.min(totalPages,p+1))} style={pagBtn(false)}>»</button>
          </div>

          {/* Rango + total */}
          <div style={{ fontSize:10, color:'#64748b' }}>
            ({desde}–{hasta}) de <strong style={{ color:'#334155' }}>{filteredData.length}</strong> resultados
          </div>

          {/* Aceptar */}
          <button onClick={closHostsListModal} style={{
            background:'#1a56db', border:'none', borderRadius:7,
            color:'#fff', fontSize:12, fontWeight:500, padding:'7px 22px', cursor:'pointer',
          }}>
            Aceptar
          </button>
        </div>
      </div>
    </div>
  </div>
  );
};

export default ModalHostStatusListNew;
